<div class="video-container">
  <button class="close-btn" (click)="closeVideoDialog()">
    <span>&times;</span>
  </button>
  <iframe class="video" src="https://www.youtube.com/embed/d4lj4LUAhXo"> </iframe>
</div>
